export const GUIDELINE_EXCEPTION_VALIDATION_PAGE = 'GuidelineExceptionValidation';
export const GUIDELINE_EXCEPTION_VALIDATION_MARKER = 'activeValidationPage';

export const markGuidelineExceptionValidationRedirect = () => {
    window.sessionStorage?.setItem(
        GUIDELINE_EXCEPTION_VALIDATION_MARKER,
        GUIDELINE_EXCEPTION_VALIDATION_PAGE
    );
};

export const shouldRenderGuidelineExceptionValidation = () => {
    const hostUrl = window.location.href.toLowerCase();
    const activeValidationPage = window.sessionStorage?.getItem(GUIDELINE_EXCEPTION_VALIDATION_MARKER);
    const shouldRender =
        activeValidationPage === GUIDELINE_EXCEPTION_VALIDATION_PAGE ||
        hostUrl.includes('guidelineexceptionvalidation') ||
        hostUrl.includes('guideline-exception-validation') ||
        hostUrl.includes('requestguidelineexception');

    if (activeValidationPage === GUIDELINE_EXCEPTION_VALIDATION_PAGE) {
        window.sessionStorage?.removeItem(GUIDELINE_EXCEPTION_VALIDATION_MARKER);
    }

    return shouldRender;
};